
import { useState, useEffect } from "react";
import { User } from "@supabase/supabase-js";
import { useInfiniteScroll } from "@/hooks/useInfiniteScroll";
import { WintersportHeader } from "./wintersport/WintersportHeader";
import { WintersportFilters } from "./wintersport/WintersportFilters";
import { WintersportResults } from "./wintersport/WintersportResults";
import { useWintersportData } from "@/hooks/useWintersportData";

interface WintersportProps {
  onBack: () => void;
  user?: User | null;
  favorites?: number[];
  onFavoriteChange?: (vacationId: number) => void;
}

export const Wintersport = ({ onBack, user = null, favorites = [], onFavoriteChange = () => {} }: WintersportProps) => {
  const [displayCount, setDisplayCount] = useState(20);
  const [searchTerm, setSearchTerm] = useState("");
  const [countryFilter, setCountryFilter] = useState("all");
  const [priceFilter, setPriceFilter] = useState("all");

  const { vacations, loading, countries } = useWintersportData(searchTerm, countryFilter, priceFilter);

  const hasMoreResults = displayCount < vacations.length;
  const displayedVacations = vacations.slice(0, displayCount);

  const { shouldLoadMore, resetLoadMore } = useInfiniteScroll({
    hasNextPage: hasMoreResults,
    isLoading: loading
  });

  useEffect(() => {
    if (shouldLoadMore) {
      setDisplayCount(prev => Math.min(prev + 20, vacations.length));
      resetLoadMore();
    }
  }, [shouldLoadMore, vacations.length, resetLoadMore]);

  return (
    <div className="space-y-6">
      <WintersportHeader onBack={onBack} />
      
      <WintersportFilters
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        countryFilter={countryFilter}
        setCountryFilter={setCountryFilter}
        priceFilter={priceFilter}
        setPriceFilter={setPriceFilter}
        countries={countries}
      />
      
      <WintersportResults
        loading={loading}
        displayedVacations={displayedVacations}
        totalVacations={vacations.length}
        hasMoreResults={hasMoreResults}
        user={user}
        favorites={favorites}
        onFavoriteChange={onFavoriteChange}
      />
    </div>
  );
};
